__turbopack_context__.v({
  "bottomSpacer": "ZestLifeDefinition-module__E6aKeW__bottomSpacer",
  "container": "ZestLifeDefinition-module__E6aKeW__container",
  "discoveryContent": "ZestLifeDefinition-module__E6aKeW__discoveryContent",
  "discoverySection": "ZestLifeDefinition-module__E6aKeW__discoverySection",
  "emailForm": "ZestLifeDefinition-module__E6aKeW__emailForm",
  "emailInput": "ZestLifeDefinition-module__E6aKeW__emailInput",
  "float": "ZestLifeDefinition-module__E6aKeW__float",
  "inner": "ZestLifeDefinition-module__E6aKeW__inner",
  "pulse": "ZestLifeDefinition-module__E6aKeW__pulse",
  "signupContent": "ZestLifeDefinition-module__E6aKeW__signupContent",
  "signupSection": "ZestLifeDefinition-module__E6aKeW__signupSection",
  "slideInUp": "ZestLifeDefinition-module__E6aKeW__slideInUp",
  "subscribeBtn": "ZestLifeDefinition-module__E6aKeW__subscribeBtn",
  "successMessage": "ZestLifeDefinition-module__E6aKeW__successMessage",
  "textfieldAndButtonContainer": "ZestLifeDefinition-module__E6aKeW__textfieldAndButtonContainer",
});
